<template lang="pug">
    .trigger
</template>

<script>
export default {
    name: 'NextPageTrigger',

    props: {
        url: {
            default: '',
            type: String
        },
        trigger: {
            default: false,
            type: Boolean
        },
        triggerstart: {
            default: false,
            type: Boolean
        }
    },

    data() {
        return {
            reachEndTriggerOnce: false,
            reachStartTriggerOnce: false
        };
    },

    watch: {
        trigger(newVal) {
            if (this.reachEndTriggerOnce && newVal) {
                setTimeout(() => {
                    this.$router.push({path: this.url}).catch(() => {});
                }, 600);
            } else if (newVal) {
                setTimeout(() => {
                    window.scrollTo(0, window.scrollY - 2);
                    this.reachEndTriggerOnce = true;
                }, 700);
            }
        },
        triggerstart(newVal) {
            if (this.reachStartTriggerOnce && newVal) {
                setTimeout(() => {
                    this.$router.push({path: this.url}).catch(() => {});
                }, 600);
            } else if (newVal) {
                this.reachStartTriggerOnce = true;
            }
        }
    },

    methods: {}
};
</script>

<style lang="scss" scoped>
.trigger {
    position: absolute;
    width: 100%;
    height: 1px;
}
</style>
